import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { DeleteSteps } from "../types";
import axiosClient from "../utils/axiosClient";

export const useDeleteExecutionDataMutation = (
  cb: (err: boolean, msg?: string) => void
) => {
  return useMutation<
    {},
    AxiosError<any>,
    {
      deleteSteps: DeleteSteps[];
      id: number;
    }
  >(
    ({ deleteSteps, id }) =>
      axiosClient
        .delete(`/execution/delete/${id}`, {
          data: {
            deleteSteps,
          },
        })
        .then(({ data }) => data),
    {
      onError: ({ response }) => {
        cb(true, "Something went wrong.");
      },
      onSuccess: () => {
        cb(false);
      },
    }
  );
};
